import { Icon } from "@/components/icon";

export function TicketPropertiesSection({
  label,
  icon,
  action,
  children,
}: {
  label: string;
  icon: string;
  action?: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div>
      <div className="flex items-center justify-between gap-x-2 mb-3">
        <div className="flex items-center gap-x-1.5 text-sm text-foreground">
          <Icon icon={icon} size={16} />
          <span className="text-xs font-medium">{label}</span>
        </div>
        {action && <div className="ml-auto">{action}</div>}
      </div>
      <div className="pl-0.5">{children}</div>
    </div>
  );
}
